import type { TourDefinition } from '../types';
import { globalTour } from './globalTour';
import { dashboardTour } from './dashboardTour';
import { emailTour } from './emailTour';
import { leadsTour } from './leadsTour';
import { companiesTour } from './companiesTour';
import { dealsTour } from './dealsTour';
import { activitiesTour } from './activitiesTour';
import { chatTour } from './chatTour';
import { leadProfileTour } from './leadProfileTour';
import { dealProfileTour } from './dealProfileTour';
import { companyProfileTour } from './companyProfileTour';

export const tourDefinitions: Record<string, TourDefinition> = {
  [globalTour.id]: globalTour,
  [dashboardTour.id]: dashboardTour,
  [emailTour.id]: emailTour,
  [leadsTour.id]: leadsTour,
  [companiesTour.id]: companiesTour,
  [dealsTour.id]: dealsTour,
  [activitiesTour.id]: activitiesTour,
  [chatTour.id]: chatTour,
  [leadProfileTour.id]: leadProfileTour,
  [dealProfileTour.id]: dealProfileTour,
  [companyProfileTour.id]: companyProfileTour,
};
